import Flickity from 'flickity'
import {animateInViewport} from '../transition'

$('.media-carousel').each(function () {
  const $this = $(this)
  const $container = $this.closest('.carousel-container')

  const swiper = new Swiper(this, {
    navigation: {
      nextEl: $container.find('.carousel-next')[0],
      prevEl: $container.find('.carousel-previous')[0],
    },
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 20,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: $container.find('.carousel-pagination')[0],
      clickable: true, // makes bullets clickable
    },
  })

  $container.find('.carousel-buttons a').on('click', function (e) {
    e.preventDefault()

    $(this).addClass('active').siblings().removeClass('active')

    const index = +$(this).data('slide-index')
    if (!isNaN(index)) swiper.slideTo(index)
  })

  swiper.on('slideChange', function () {
    const activeIndex = swiper.activeIndex

    $container
      .find('.carousel-buttons a')
      .removeClass('active')
      .filter('[data-slide-index="' + activeIndex + '"]')
      .addClass('active')
  })
})

$('.floor-carousel').each(function () {
  const $this = $(this)

  let swiper = new Swiper(this, {
    grabCursor: false,
    slidesPerView: 1,
    spaceBetween: 0,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoHeight: true,
    loop: false,
    allowTouchMove: false,
    navigation: false,
    pagination: {
      el: $this.parents('.floor-carousel-container').find('.floor-bullets')[0],
      clickable: true,
      renderBullet: function (index, className) {
        const title = $this
          .parents('.floor-carousel-container')
          .find('.floor-slide')
          .eq(index)
          .attr('data-title')

        return (
          '<span class="group inline-flex items-center gap-[8px] hover:opacity-75 invisible-link inline-block leading-[100%] uppercase px-[20px] py-[12px] rounded-[6px] ' +
          className +
          '">' +
          title +
          '</span>'
        )
      },
    },
  })

  $this
    .parents('.floor-carousel-container')
    .find('.floor-bullet')
    .on('click', function () {
      toggleFloorOptions()
    })
})

$('.floor-toggle-button').on('click', function () {
  toggleFloorOptions()
})

function toggleFloorOptions() {
  $('.floor-toggle-options').slideToggle(300)
  $('.floor-toggle-options-container').toggleClass('bg-light-beige-2')
  $('.floor-toggle-button .icon').toggleClass('rotate-45')
}

$('.version-carousel').each(function () {
  const $this = $(this)

  let swiper = new Swiper(this, {
    navigation: {
      nextEl: $this.parents('.version-carousel-container').find('.carousel-next')[0],
      prevEl: $this.parents('.version-carousel-container').find('.carousel-previous')[0],
    },
    loop: true,
    grabCursor: true,
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoHeight: true,
    pagination: {
      el: $this.parents('.version-carousel-container').find('.version-bullets')[0],
      clickable: true,
      renderBullet: function (index, className) {
        const title = $this
          .parents('.version-carousel-container')
          .find('.version-slide')
          .eq(index)
          .attr('data-title')

        return (
          '<span class="version-bullet transition-all bg-color-2 text-color-1 rounded-[4px] px-2 py-0.5 invisible-link paragraph-3 ' +
          className +
          '">' +
          title +
          '</span>'
        )
      },
    },
  })
})
